import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../i18n";
import type { Project } from "../../api/useProjects";

export const useSourceDataInput = (projects: Project[], preselectedSource?: string) => {
  const hasSameValue = React.useMemo(
    () => [...new Set(projects.map(p => p.sourceId).filter(d => d !== undefined))].length === 1,
    [projects],
  );

  const defaultValue = React.useMemo(() => {
    if (preselectedSource) return preselectedSource;
    if (hasSameValue) return projects[0]?.sourceId ?? "";
    return "";
  }, [hasSameValue, projects, preselectedSource]);

  const {
    value: sourceValue,
    setValue: setSourceValue,
    onChange: handleSourceValueChanged,
    dirty: isSourceValueDirty,
  } = useInput(defaultValue);

  const handleRollbackSources = React.useCallback(() => {
    setSourceValue(defaultValue);
  }, [setSourceValue, defaultValue]);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue && projects.length > 1) {
      return t("projects.modal.multiple_value");
    }
    if (defaultValue === "") {
      return t("projects.modal.dataSource");
    }
    return defaultValue;
  }, [defaultValue, hasSameValue, projects.length]);

  return {
    placeholder,
    sourceValue,
    setSourceValue,
    handleSourceValueChanged,
    isSourceValueDirty,
    handleRollbackSources,
  };
};
